import React from "react";
import { Link } from "react-router-dom";

const Sidebar = () => {
  return (
    <>
      <div id="wrapper">
        <ul
          className="navbar-nav bg-gradient-primary sidebar sidebar-dark toggled" data-toggle="collapse" id="accordionSidebar">
          <Link className="sidebar-brand d-flex align-items-center justify-content-center mt-5 mb-4" to={"/"}>
            <img src="/img/sesc-logo-branca.png"  width="90"  height="75"  className="rounded mx-auto d-block" alt="logo SESC Alagoas"/>
          </Link>
          <hr className="sidebar-divider my-0" />
          <li className="nav-item active">
            <Link className="nav-link" to={"/credencial"}>
              <i className="fas fa-user"></i>
              <span>Credencial</span>
            </Link>
          </li>

          <li className="nav-item active">
            <Link className="nav-link" to={"/credencial-dependentes"}>
              

            <i className="fas fa-users"></i>
              <span>Dependentes</span>
            </Link>
          </li>


          
          <hr className="sidebar-divider d-none d-md-block" />
          <div className="text-center d-none d-md-inline">
            <button className="rounded-circle border-0" id="sidebarToggle"></button>
          </div>
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
